import React__default, { useState, useEffect } from 'react';
import classNames from 'classnames';
import AppBtn from '../app-btn/AppBtn.js';
import Styles from './InlinePillSelect.module.scss.js';

const InlinePillSelect = ({ customize, options, customizeText = "Customize", value, setValue, valueAfterClearing, setFormikTouched, showError, touched, errors }) => {
    const [customizedClick, setCustomizedClick] = useState(false);
    const [savedClicked, setSavedClicked] = useState(false);
    const [customizedOption, setCustomizedOption] = useState(value);
    useEffect(() => {
        if (JSON.stringify(value) !== JSON.stringify(valueAfterClearing)) {
            let valueInOption = false;
            for (const option of options) {
                if (JSON.stringify(option) === JSON.stringify(value)) {
                    valueInOption = true;
                }
            }
            if (!valueInOption) {
                setCustomizedClick(true);
                setSavedClicked(true);
                if (setFormikTouched)
                    setFormikTouched();
            }
        }
    }, []);
    const handleDefaultOptionSelection = (optionObj) => {
        setCustomizedClick(false);
        setSavedClicked(false);
        setValue(optionObj);
    };
    const renderOption = (optionObj) => {
        if (typeof optionObj === "number" || typeof optionObj === "string")
            return (React__default.createElement("div", { className: Styles.option, key: optionObj }, optionObj));
        let optionText = "";
        const isSelected = JSON.stringify(optionObj) === JSON.stringify(value);
        const keys = Object.keys(optionObj);
        keys.forEach((key) => (optionText += `${optionObj[key]} ${key} `));
        return (React__default.createElement("div", { className: classNames(Styles.option, isSelected && Styles.optionSelected), key: optionText, onClick: () => handleDefaultOptionSelection(optionObj) }, optionText));
    };
    const renderCustomizeOption = () => {
        const firstOption = options[0];
        if (!firstOption)
            return;
        const arr = [];
        const keys = Object.keys(firstOption);
        if (customizedOption)
            keys.forEach((key) => {
                arr.push(React__default.createElement("span", { className: Styles.customizedInputSpan, key: key },
                    React__default.createElement("input", { name: key, value: customizedOption[key], onChange: (e) => {
                            let val = e.target.value;
                            if (typeof firstOption[key] === "number") {
                                val = parseInt(val.toString());
                                if (isNaN(val))
                                    val = "";
                            }
                            const obj = Object.assign({}, customizedOption);
                            obj[e.target.name] = val;
                            setCustomizedOption(obj);
                        } }),
                    " ",
                    key));
            });
        return React__default.createElement("div", { className: Styles.inputsDiv }, arr.map((input) => input));
    };
    const renderCustomizedSaveOption = () => {
        let text = "";
        if (customizedOption)
            Object.keys(customizedOption).forEach((key) => (text += `${customizedOption[key]} ${key} `));
        return text;
    };
    const handleSavedClicked = () => {
        const optionSelected = Object.assign({}, customizedOption);
        const firstOption = options[0];
        if (!firstOption)
            return;
        const keys = Object.keys(firstOption);
        keys.forEach((key) => {
            if (typeof firstOption[key] === "number") {
                if (optionSelected[key] === "") {
                    optionSelected[key] = 0;
                }
            }
        });
        setCustomizedOption(optionSelected);
        setValue(optionSelected);
        setSavedClicked(true);
    };
    const handleDiscardClickAfterSaved = () => {
        setCustomizedClick(false);
        setValue(valueAfterClearing);
    };
    const renderErrorFromArray = (errors) => {
        for (const error of errors) {
            if (error)
                return error;
        }
        return "";
    };
    const render = () => {
        if (customize && !customizedClick)
            return (React__default.createElement("div", { className: Styles.option, onClick: () => setCustomizedClick(true) }, customizeText));
        else if (customize && customizedClick && savedClicked) {
            return (React__default.createElement("div", { className: classNames(Styles.option, Styles.optionSelected) },
                React__default.createElement("span", { className: Styles.savedOption }, renderCustomizedSaveOption()),
                React__default.createElement("span", { className: Styles.divider }),
                React__default.createElement("span", { className: Styles.edit, onClick: () => setSavedClicked(false) }, "Edit")));
        }
        else if (customize && customizedClick) {
            return (React__default.createElement("div", { className: classNames(Styles.option, Styles.customizing) },
                renderCustomizeOption(),
                " ",
                React__default.createElement("span", { className: Styles.actionBtn },
                    React__default.createElement(AppBtn, { className: Styles.btn, onClick: handleSavedClicked }, "Save"),
                    React__default.createElement(AppBtn, { onClick: handleDiscardClickAfterSaved, fillType: "outline", className: classNames(Styles.btn, Styles.discardBtn) }, "Discard"))));
        }
        else
            return React__default.createElement(React__default.Fragment, null, " ");
    };
    return (React__default.createElement("div", { onClick: setFormikTouched },
        options.map((option) => renderOption(option)),
        render(),
        showError && touched && customizedClick && savedClicked ? (Array.isArray(errors) ? (React__default.createElement("p", { className: Styles.errorClass }, renderErrorFromArray(errors))) : (React__default.createElement("p", { className: Styles.errorClass }, errors || ""))) : (React__default.createElement(React__default.Fragment, null))));
};

export { InlinePillSelect as default };
//# sourceMappingURL=InlinePillSelect.js.map
